import { createContext, PropsWithChildren, useContext } from 'react';

interface EnvContextProps {
  targetEnv: string;
}

export const EnvContext = createContext<EnvContextProps>({ targetEnv: 'production' });

export const useEnvContext = () => useContext(EnvContext);

export default function EnvProvider({ targetEnv, children }: PropsWithChildren<EnvContextProps>) {
  return <EnvContext.Provider value={{ targetEnv }}>{children}</EnvContext.Provider>;
}
